import { LeftChevron } from 'assets/Icons'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Header = () => {
	const navigate = useNavigate()
	return (
		<div className='flex items-center justify-start gap-1 sm:gap-2'>
			<span
				className='p-1 rounded-[10px] text-[#292A32] dark:text-[#ffffff] hover:text-[#018ECC] dark:hover:text-[#018ECC] hover:cursor-pointer hover:bg-[#e8e8e8] dark:hover:bg-[#414141]'
				onClick={() => navigate('/account/students')}
			>
				<LeftChevron />
			</span>
			<h1 className='text-[18px] lg:text-[24px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
				O'quvchi ma'lumotlarini tahrirlash
			</h1>
		</div>
	)
}

export default Header
